/**
 * Storage path for a compose attachment. It MUST be the exact original
 * filename: the send path reads `user/{uid}/email/attachments/{name}`
 * verbatim (`SharedGatewayService.fetchFileFromStorage`). The old
 * split-and-rejoin (`base + '.' + extension`) turned an extension-less file
 * into `.undefined`, so the sender looked for a path nothing was ever
 * uploaded to and the attachment silently vanished from the sent mail (G5).
 *
 * Standalone module (no service imports): `FileService` uploads to it and
 * `InlineImageService` resolves drop-to-embed inline images from it.
 */
export function attachmentStoragePath(uid: string, filename: string): string {
    return `user/${uid}/email/attachments/${filename}`;
}
